export const NewsCardData = [
    {
        id: 1
        ,title: 'Welcome'
        ,image: 'Logos/vibe_square.png'
        ,text: 'At The Vibe Collective, we empower individuals on their personal journeys with ' + 
                'insightful guidance and transformational experiences. Our diverse services include tarot ' +
                'readings, astrology, mediumship, remote reiki, yoga, sound healing, and more. Each ' +
                'service, event, class, and product are curated to provide profound insights and support ' +
                'you in living your most abundant life. '
        ,text2: 'Stay tuned as we regularly release new items in our shop, launch classes, and add ' +
                'exciting services to our platform. '
        ,text3: 'The magic and knowledge you seek are already within you here to help you ' +
                'harness and embrace them. Join us and discover the power within. '
        ,imageLeftSide: true
        ,styleId: 'newscard-blurb1'
    },
    {
        id: 2
        ,title: 'Our Approach'
        ,image: 'Landscapes/jpeg/floating.jpg'
        ,text: 'At The Vibe Collective, we support your personal journey by putting the power back into ' +
                'your hands. Leading with authenticity, our readings guide you, provide answers to your ' +
                'most pressing questions, and uncover valuable insights into the energy around you and ' +
                'the messages you need right now. In an industry often marred by fraud and deception, ' +
                'we are committed to offering genuine, carefully crafted experiences.'
        ,text2: 'We support you through our curated shop, energetically aligned classes, and insightful ' +
                'readings. This is magic for the new age, tailored to what works for YOU. Come raise your ' +
                'VIBE with us and discover the power within. '
        ,text3: null
        ,imageLeftSide: false
        ,styleId: 'newscard-blurb2'
    },
    {
        id: 3
        ,title: 'The Path to Self-Discovery'
        ,image: 'Landscapes/jpeg/mountainPool.jpg'
        ,text: 'Embark on a journey of profound self-discovery with our offerings. We provide the tools ' +
                'and experiences to help you explore your inner world, unlocking messages from within ' +
                'and create connection with your spirit guides, angels, and ancestors. Your path is ' +
                'unique, and we\'re here to support you every step of the way. Ensuring a safe, ' +
                'thoughtful, and transformative journey. '
        ,imageLeftSide: true
        ,styleId: 'newscard-blurb3'
    }
]